export default {
  IcbLevel1: 'Icb Level 1',
  IcbLevel2: 'Icb Level 2',
  IcbLevel3: 'Icb Level 3',
  IcbLevel4: 'Icb Level 4',
  listTitleTable: {
    ICB_NAME: 'SECTOR',
    CLOSE_INDEX: 'Last',
    INDEX_CHANGE: 'Change',
    PERCENT_INDEX_CHANGE: '%Change',
    TOTAL_MATCH_VOLUME: 'Match Volume',
    TOTAL_MATCH_VALUE: 'Match Value',
    FOREIGN_BUY_VOL_MATCHED: 'Fr. Buy Vol',
    FOREIGN_SELL_VOL_MATCHED: 'Fr. Sell Vol',
    FOREIGN_BUY_VALUE_MATCHED: 'Fr. Buy Val',
    FOREIGN_SELL_VALUE_MATCHED: 'Fr. Sell Val',
    FOREIGN_NET_VOLUME: 'Net Fr. Vol',
    FOREIGN_NET_VALUE: 'Net Fr. Val',
    TOTAL_DEAL_VOLUME: 'Deal Volume',
    TOTAL_DEAL_VALUE: 'Deal Value',
    TOTAL_VOLUME: 'Total Volume',
    TOTAL_VALUE: 'Total Value',
    TOTAL_COMPANY: 'Total Company',
    PE: 'P/E',
    PB: 'P/B',
    OUT_STANDING_SHARES: 'Outstanding Shares',
    MARKET_CAP: 'Market Cap',
    EPS: 'EPS (TTM)',
    BVPS: 'BVPS (TTM)',
    ROE: 'ROE (TTM)',
    ROA: 'ROA (TTM)',
    EQUITY: '(ST+LT borrowings)/Equity',
    DE: 'D/E',
    NIM: 'NIM',
    NPL: 'NPL',
    PERCENT_PRICE_CHANGE_1WEEK: '% 1 Week',
    PERCENT_PRICE_CHANGE_2WEEK: '% 2 Weeks',
    PERCENT_PRICE_CHANGE_1MONTH: '% 1 Month',
    PERCENT_PRICE_CHANGE_3MONTH: '% 3 Months',
    PERCENT_PRICE_CHANGE_6MONTH: '% 6 Months',
    PERCENT_PRICE_CHANGE_9MONTH: '% 9 Months',
    PERCENT_PRICE_CHANGE_1YEAR: '% 1 Year',
    PERCENT_PRICE_CHANGE_YTD: '% YTD',
    AVERAGE_MATCHED_VOLUME_1WEEK: 'Avg Vol. 1W',
    AVERAGE_MATCHED_VOLUME_2WEEK: 'Avg Vol. 2W',
    AVERAGE_MATCHED_VOLUME_1MONTH: 'Avg Vol. 1M',
    AVERAGE_MATCHED_VOLUME_3MONTH: 'Avg Vol. 3M',
  },
  footer:
    'Volume: x 1,000. Value: x 1,000,000. Each sectors include all tickers from HOSE, HNX and UPCOM. (Hose realtime data is intergrated into industrial realtime data after 9h15 AM)',
};
